export default "__VITE_ASSET__uOeeBRhb__"